const LiveProgressMock = () => (
  <div className="space-y-4">
    {/* Live Validation Progress -- matches ReadinessOrProgressPanel.tsx LIVE mode */}
    <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
      <div className="p-3">
        <div className="bg-[#181825] border border-white/[0.06] rounded-lg p-3">
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-xs font-medium text-gray-400 uppercase tracking-wide">
              Live Validation Progress
            </h4>
            <span className="text-xs text-gray-500">
              Est. re-optimization: <span className="text-cyan-400">~8.6 months</span>
            </span>
          </div>

          <div className="space-y-3">
            <div className="w-full">
              <div className="flex justify-between text-xs text-gray-400 mb-1">
                <span>Candles to Re-optimization</span>
                <span>461 / 720</span>
              </div>
              <div className="h-2 bg-gray-700 rounded-full overflow-hidden">
                <div className="h-full bg-cyan-500 rounded-full" style={{ width: '64%' }} />
              </div>
            </div>

            <div className="flex justify-between text-sm">
              <div>
                <span className="text-gray-400">Trades: </span>
                <span className="text-white font-medium">12</span>
                <span className="text-gray-500 text-xs ml-1">(min: 5)</span>
              </div>
              <div>
                <span className="text-gray-400">Progress: </span>
                <span className="text-cyan-400 font-medium">64%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Active Strategy Parameters -- matches ActiveParametersPanel.tsx */}
    <div className="rounded-lg overflow-hidden shadow-2xl shadow-black/30 border border-white/[0.06] font-mono" style={{ background: '#0f1923' }}>
      <div className="p-3">
        <div className="bg-[#181825] border border-white/[0.06] rounded-lg p-3">
          <h4 className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-2">
            Active Strategy Parameters
          </h4>

          <div className="flex flex-wrap gap-1.5 mb-3">
            {[
              { name: 'fastLength', value: '34' },
              { name: 'slowLength', value: '40' },
            ].map((p) => (
              <div key={p.name} className="inline-flex items-center gap-1.5 bg-gray-800 rounded-md px-2 py-1">
                <span className="text-xs text-gray-400">{p.name}:</span>
                <span className="text-xs text-white font-medium">{p.value}</span>
              </div>
            ))}
          </div>

          <div className="text-xs text-gray-500">
            Last optimized: <span className="text-gray-300">Mar 3, 2026</span>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default LiveProgressMock;
